import type { CSSProperties } from 'react'
import type { WidgetSize } from '../types'
import { GRID_GAP, ROW_HEIGHT } from './model'

export type GridColumns = 1 | 2 | 4

const GRID_COLS: Record<GridColumns, string> = { 1: 'grid-cols-1', 2: 'grid-cols-2', 4: 'grid-cols-4' }
const COL_SPAN: Record<WidgetSize, string> = { 1: 'col-span-1', 2: 'col-span-2', 3: 'col-span-3', 4: 'col-span-4' }
const ROW_SPAN: Record<WidgetSize, string> = { 1: 'row-span-1', 2: 'row-span-2', 3: 'row-span-3', 4: 'row-span-4' }

/** Sütun sayısı verilmezse grid, kapsayıcı genişliğine göre 1 → 2 → 4 sütuna geçer. */
const RESPONSIVE_GRID = 'grid-cols-1 @2xl:grid-cols-2 @5xl:grid-cols-4'
const RESPONSIVE_SPAN: Record<WidgetSize, string> = {
  1: 'col-span-1',
  2: 'col-span-1 @2xl:col-span-2',
  3: 'col-span-1 @2xl:col-span-2 @5xl:col-span-3',
  4: 'col-span-1 @2xl:col-span-2 @5xl:col-span-4',
}

export const gridClass = (cols?: GridColumns) => `grid ${cols ? GRID_COLS[cols] : RESPONSIVE_GRID}`

export const gridStyle: CSSProperties = { gridAutoRows: `${ROW_HEIGHT}px`, gap: `${GRID_GAP}px` }

export function cellClass(w: WidgetSize, h: WidgetSize, cols?: GridColumns) {
  const col = cols ? COL_SPAN[Math.min(w, cols) as WidgetSize] : RESPONSIVE_SPAN[w]
  return `${col} ${ROW_SPAN[h]}`
}
